import clsx from 'clsx';

const cuisines = [
  { value: 'Chinese', label: 'Chinese', color: 'bg-red-100 text-red-800 border-red-200' },
  { value: 'Japanese', label: 'Japanese', color: 'bg-pink-100 text-pink-800 border-pink-200' },
  { value: 'Korean', label: 'Korean', color: 'bg-blue-100 text-blue-800 border-blue-200' },
  { value: 'Vietnamese', label: 'Vietnamese', color: 'bg-yellow-100 text-yellow-800 border-yellow-200' },
  { value: 'Thai', label: 'Thai', color: 'bg-orange-100 text-orange-800 border-orange-200' },
  { value: 'Asian', label: 'Other Asian', color: 'bg-purple-100 text-purple-800 border-purple-200' },
];

interface CuisineFilterProps {
  selected: string[];
  onChange: (cuisines: string[]) => void;
}

export function CuisineFilter({ selected, onChange }: CuisineFilterProps) {
  const toggleCuisine = (cuisine: string) => {
    if (selected.includes(cuisine)) {
      onChange(selected.filter((c) => c !== cuisine));
    } else {
      onChange([...selected, cuisine]);
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-font-primary">Cuisine</label>
      <div className="flex flex-wrap gap-2">
        {cuisines.map((cuisine) => {
          const isSelected = selected.includes(cuisine.value);
          return (
            <button
              key={cuisine.value}
              onClick={() => toggleCuisine(cuisine.value)}
              className={clsx(
                'px-3 py-1.5 rounded-full text-sm font-medium border transition-all',
                isSelected
                  ? cuisine.color
                  : 'bg-white text-font-secondary border-card-border hover:border-brand-primary'
              )}
            >
              {cuisine.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
